import React, { lazy, useState } from "react";
import { ModalDeleteConfirm, Modal, MasterButton } from "App/Component/ui";
import {
  convertToValidPrice,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
  titleModal,
  today,
  toUTCFormat,
} from "App/utils/helpers";
import { DEFAULT_SHOW_BUTTON_SUBMIT, instance3 } from "App/constants";
import { Add } from "@material-ui/icons";
import FormTabSaldo from "./FormTabSaldo";
import { deleteSaldoByID } from ".";

const TableListSaldoByKunjungan = lazy(() =>
  import("./TableListSaldoByKunjungan")
);

export default function TabSaldo({ rows, kunjunganID, setNewDataSaldo, handleClickCetak }) {
  const [showModal, setShowModal] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    date: today(true),
    amount2: 0,
    kas_id: null,
    tipe_pembayaran_id: 1,
    kas_name: "Pilih Kas",
    tipe_kartu: 1,
    no_transaksi: "",
    no_kartu: "",
  });

  function clickUpdate(row) {
    setFormData({
      id: row.id,
      id_kunjungan: row.id_kunjungan,
      date: defaultDateInputDisplay(row.date, true),
      jenis_bayar: 1,
      tipe_pembayaran_id: row.tipe_pembayaran_id,
      amount2: formatRupiah(row.amount),
      kas_id: row.id_kas,
      kas_name: row.namaKas,
      tipe_kartu: row.tipe_kartu_id,
      no_kartu: row.no_kartu,
      no_transfer: row.no_transfer,
      kartu_bank: row.kartu_bank,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function deleteList() {
    const res = await deleteSaldoByID(formData.id);

    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewDataSaldo();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      {showModal && (
        <ModalForm
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
          kunjunganID={kunjunganID}
          setNewDataSaldo={setNewDataSaldo}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {!isNull(kunjunganID) && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}>
          <MasterButton
            type={"button"}
            color='green'
            name='TAMBAH'
            size='sm'
            onClick={() => setShowModal(!showModal)}
            withIcon={true}
            icon={
              <Add
                width='17px'
                height='17px'
                style={{
                  marginLeft: "-0.5rem",
                }}
              />
            }
          />
        </div>
      )}

      <TableListSaldoByKunjungan
        clickDelete={clickDelete}
        clickUpdate={clickUpdate}
        rows={rows}
        handleClickCetak={handleClickCetak}
      />
    </>
  );
}

const ModalForm = ({
  formData,
  setFormData,
  setShowModal,
  kunjunganID,
  setNewDataSaldo,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const save = async () => {
    const defaultData = {
      date: toUTCFormat(formData.date),
      amount: convertToValidPrice(formData.amount2),
      tipe_pembayaran_id: formData.tipe_pembayaran_id,
      id_kas: formData.kas_id,
      tipe_kartu: formData.tipe_kartu,
      no_transaksi: formData.no_transaksi,
      jenis_bayar: 1,
      no_kartu: formData.no_kartu,
      no_transfer: formData.no_transfer,
      kartu_bank: formData.kartu_bank,
      id_kunjungan: kunjunganID,
    };

    if (isNull(formData.id)) {
      return instance3.post("/kas/saldo/add", defaultData);
    } else {
      return instance3.post(
        "/kas/saldo/update",
        {
          ...defaultData,
          id: formData.id,
        },
        {
          headers: {
            id: formData.id,
          },
        }
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isNull(kunjunganID)) {
      defaultToastError("Pili kunjungan terlebih dahulu");
    } else {
      try {
        const res = await save();
        if (res.data.status === 200) {
          if (isNull(formData.id)) {
            defaultToastSuccess("Berhasil menambah data");
            await setNewDataSaldo(kunjunganID);
          } else {
            defaultToastSuccess("Berhasil mengubah data");
            await setNewDataSaldo(kunjunganID);
          }
          setShowModal(false);
        } else {
          defaultToastError(res.data.message);
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Saldo`}
      width='50%'
      show={setShowModal}>
      <FormTabSaldo
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        formData={formData}
        setFormData={setFormData}
        disabled={disabled}
        isSaldo={true}
      />
    </Modal>
  );
};
